module.exports = __webpack_public_path__ + "img/ceramic-love.ef41a72f.jpg";